export default __webpack_public_path__ + "static/re-public-87834ca25cda39f28305e1b2824dc746.svg";